import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'

import {withTitle} from '@/router/utils'
import {OutletListFilterContainer, OutletsContainer} from '@/components'

export const POSOutletsStoreSymbol = Symbol('POSOutletsStoreSymbol')
export const POSOutletsPaginationStoreSymbol = Symbol('POSOutletsPaginationStoreSymbol')
export const POSOutletsStatusStoreSymbol = Symbol('POSOutletsStatusStoreSymbol')
export const POSOutletListFilterStoreSymbol = Symbol('POSOutletListFilterStoreSymbol')

const POSOutlets: React.FC<null> = observer(() => {
    const { t } = useTranslation()
    return (
        <OutletsContainer
            injectableIdentifier={POSOutletsStoreSymbol}
            paginationInjectableIdentifier={POSOutletsPaginationStoreSymbol}
            containerTitle={t('POSOutlets.posOutlets')}
            extra={
                <OutletListFilterContainer injectableIdentifier={POSOutletListFilterStoreSymbol} />
            }
        />
    )
})

export default withTitle(POSOutlets, 'POSOutlets.posOutlets')
